/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { menuManagerItemDtoSchema } from './menuManagerItemDtoSchema.ts';
import { z } from 'zod';

/**
 * @description OK
 */
export const getApiMenuManager200Schema = z.array(
  z.lazy(() => menuManagerItemDtoSchema),
);

export const getApiMenuManagerQueryResponseSchema = z.lazy(
  () => getApiMenuManager200Schema,
);
